import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { MeasureInteractors } from './interactors';
import { EditMeasures } from './../cmd/EditMeasure';
import { MeasureEnding } from './../mdl/Measure';
import { MeasureSnapping } from './MeasureSnapping';
import { Util } from "../utils/Util";
import { perpendicularVector2 } from "@egr/wcf/modules/core/utils/MathUtils";
export class MoveMeasure extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pMode, pMeasure) {
        this.mMode = pMode;
        this.mMeasure = pMeasure;
        this.mCommand = new EditMeasures(this.mRoomManager);
        this.mMeasureSnapping = new MeasureSnapping(this.mRoomManager);
        if (pMode != MoveMeasure.Mode.LineOffset)
            this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        let tPos = pPos;
        if (this.mMode != MoveMeasure.Mode.LineOffset)
            tPos = this.performSnapping(pPos);
        let tdir_perp = perpendicularVector2(this.mMeasure.measureDirection).negate();
        let tISpoint = Util.getIntersectionPointV2(this.mMeasure.startPoint, this.mMeasure.endPoint, Util.to2d(pPos), Util.to2d(pPos).add(tdir_perp), false);
        this.mCurrentPos = Util.to2d(tPos);
        switch (this.mMode) {
            case MoveMeasure.Mode.MoveStart:
                this.mMeasure.setStartPoint(this.mCurrentPos);
                break;
            case MoveMeasure.Mode.MoveEnd:
                this.mMeasure.setEndPoint(this.mCurrentPos);
                break;
            case MoveMeasure.Mode.MoveMeasure:
                let tCenter = Vector2.Center(this.mMeasure.startPoint, this.mMeasure.endPoint);
                this.mMeasure.moveMeasure(this.mCurrentPos.subtract(tCenter));
                break;
            case MoveMeasure.Mode.LineOffset:
                if (tISpoint != null) {
                    let tpos2d = Util.to2d(pPos);
                    let tcurrDir = (tpos2d.subtract(tISpoint)).normalize();
                    let taSign = Util.vectorEquals2(tcurrDir, tdir_perp) ? 1 : -1;
                    let tDist = Vector2.Distance(Util.to2d(pPos), tISpoint);
                    this.mMeasure.setLineOffset(taSign * (tDist + 0.1));
                }
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (this.mCommand != null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                if (this.mLengthFeedback != null)
                    this.mLengthFeedback._updateLengthInteractors();
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        if (this.mMode !== MoveMeasure.Mode.MoveMeasure) {
            this.mMeasureSnapping.prepareSnapping(this.mMeasure, this.mMode === MoveMeasure.Mode.MoveStart ?
                MeasureEnding.End : MeasureEnding.Start);
        }
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new MeasureInteractors(this.mRoomManager, this.mMeasure);
        this.mLengthFeedback._updateLengthInteractors();
    }
    updateFeedback() {
        super.updateFeedback();
        //if (this.mLengthFeedback != null)
        //    this.mLengthFeedback._updateLengthInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        this.mMeasureSnapping.clear();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    performSnapping(pPos) {
        return (this.mMeasureSnapping.snap(pPos, this.mView));
    }
}
//add nested types
(function (MoveMeasure) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MoveStart"] = 0] = "MoveStart";
        Mode[Mode["MoveEnd"] = 1] = "MoveEnd";
        Mode[Mode["MoveMeasure"] = 2] = "MoveMeasure";
        Mode[Mode["LineOffset"] = 3] = "LineOffset";
    })(Mode = MoveMeasure.Mode || (MoveMeasure.Mode = {}));
})(MoveMeasure || (MoveMeasure = {}));
